import { MantineColorScheme } from '@mantine/core';

/**
 * Estilos glassmorphism para inputs de formulario
 * Usado en Login y formularios de registro
 */
export const getGlassmorphismInputStyles = (colorScheme: MantineColorScheme) => ({
  input: {
    backgroundColor: colorScheme === 'dark'
      ? 'rgba(30, 41, 59, 0.95)'
      : 'rgba(247, 243, 238, 0.95)',
    backdropFilter: 'blur(40px) saturate(200%)',
    WebkitBackdropFilter: 'blur(40px) saturate(200%)',
    border: `1px solid ${colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(221, 216, 209, 0.6)'}`,
    boxShadow: colorScheme === 'dark'
      ? 'inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 16px rgba(0, 0, 0, 0.2)'
      : '0 4px 16px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
    color: colorScheme === 'dark' ? '#e2e8f0' : '#2d2a26',
    fontFamily: 'Inter, sans-serif',
  },
  // Dropdown del Select
  dropdown: {
    backgroundColor: colorScheme === 'dark'
      ? 'rgba(30, 41, 59, 0.98)'
      : 'rgba(247, 243, 238, 0.98)',
    backdropFilter: 'blur(40px) saturate(200%)',
    WebkitBackdropFilter: 'blur(40px) saturate(200%)',
    border: `1px solid ${colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(221, 216, 209, 0.8)'}`,
    boxShadow: colorScheme === 'dark'
      ? '0 8px 32px rgba(0, 0, 0, 0.4)'
      : '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  // Opciones del dropdown
  option: {
    color: colorScheme === 'dark' ? '#e2e8f0' : '#2d2a26',
    '&[data-selected]': {
      backgroundColor: colorScheme === 'dark'
        ? 'rgba(59, 130, 246, 0.3)'
        : 'rgba(59, 130, 246, 0.2)',
    },
    '&[data-hovered]': {
      backgroundColor: colorScheme === 'dark'
        ? 'rgba(59, 130, 246, 0.2)'
        : 'rgba(59, 130, 246, 0.1)',
    },
  }
});

/**
 * Props comunes para inputs con estilo glassmorphism
 */
export const glassmorphismInputProps = {
  radius: 'xl' as const,
  size: 'md' as const,
};

/**
 * Estilos planos y redondeados (sin glassmorphism)
 * Para formularios dentro de páginas de configuración
 */
export const getFlatRoundedInputStyles = (colorScheme: MantineColorScheme) => ({
  input: {
    backgroundColor: colorScheme === 'dark' ? 'rgba(30, 41, 59, 0.6)' : '#f8f4ef',
    border: `1px solid ${colorScheme === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
    boxShadow: 'none',
    color: colorScheme === 'dark' ? '#e2e8f0' : '#2d2a26',
    fontFamily: 'Inter, sans-serif',
  },
  dropdown: {
    backgroundColor: colorScheme === 'dark' ? 'rgba(30, 41, 59, 0.95)' : '#f8f4ef',
    border: `1px solid ${colorScheme === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
    boxShadow: 'none',
  },
  option: {
    color: colorScheme === 'dark' ? '#e2e8f0' : '#2d2a26',
    '&[data-selected]': {
      backgroundColor: colorScheme === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.12)',
    },
    '&[data-hovered]': {
      backgroundColor: colorScheme === 'dark' ? 'rgba(59, 130, 246, 0.12)' : 'rgba(0, 0, 0, 0.04)',
    },
  },
});

export const flatRoundedInputProps = {
  radius: 'xl' as const,
  size: 'md' as const,
};
